
<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.24897 3.48701L7.54019 7.10687L3.71702 7.68922C3.03141 7.79311 2.75665 8.67621 3.25384 9.182L6.01982 11.9981L5.36562 15.9761C5.24786 16.6951 5.97272 17.2337 6.57982 16.8975L10 15.0192L13.4202 16.8975C14.0273 17.231 14.7521 16.6951 14.6344 15.9761L13.9802 11.9981L16.7462 9.182C17.2434 8.67621 16.9686 7.79311 16.283 7.68922L12.4598 7.10687L10.751 3.48701C10.4449 2.84177 9.55776 2.83357 9.24897 3.48701Z"
      :fill="semanticColorLookup('inverse.primary')"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconsGoldenStar'
}
</script>
